import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnDestroy,
} from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { DeviceSettingsService } from '../device-settings.service';
import { NotificationService } from 'src/app/shared/errors/notification.service';
import { CommonService } from 'src/app/shared/utils/common.service';
import { HelperService } from 'src/app/shared/utils/helper.service';
import { ConfirmRemoveDialogComponent } from 'src/app/shared-layout/Components/confirm-remove-dialog/confirm-remove-dialog.component';
import { FloorManagementService } from 'src/app/floor-management/floor-management.service';
import { ViewAlertDetailsComponent } from '../../building-unit-details/view-alert-details/view-alert-details.component';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { Subscription } from 'rxjs';
import { deviceStatusResponse } from 'src/app/shared/constants/response-mapping';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { TranslateService } from '@ngx-translate/core';
import { BRANDS } from 'src/app/shared/models/screen-size.enum';

@Component({
  selector: 'app-device-details',
  templateUrl: './device-details.component.html',
  styleUrls: ['./device-details.component.scss'],
})
export class DeviceDetailsComponent implements OnInit, OnDestroy {
  /**
   * all necessary input get values from parent
   */
  @Input() formGroupName!: string;
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();
  formGroup!: FormGroup;
  readonly LANG_CONST = LANG_CONST;
  CONSTANTS = CONSTANTS;
  submited: boolean = false;
  sharedData: any;
  selectedUnitName: any;
  subscription: Subscription | undefined;
  @Input() parentType!: string;
  @Input() deviceType!: string;
  @Input() isDeviceEnabled!: string;
  @Input() activationState!: string;
  @Input() batteryPercentage!: string;
  deviceStatusResponse = deviceStatusResponse;
  selectedSiteId?: String | null;
  selectedBuildingId?: String | null;
  selectedFloorId?: String | null;

  get formInstance() {
    return this.formGroup.controls;
  }
  constructor(
    private rootFormGroup: FormGroupDirective,
    private deviceSettingservice: DeviceSettingsService,
    private notificationService: NotificationService,
    private commonService: CommonService,
    private helperService: HelperService,
    private floorManagementService: FloorManagementService,
    private sharedDataService: SharedDataService,
    private stateManagementService: StateManagementService,
    private translate: TranslateService
  ) {}

  /**
   * @description this is onInit life cycle method
   */
  ngOnInit(): void {
    this.selectedSiteId =
      this.stateManagementService.getSharedData()?.selectedSite?.siteId;
    this.selectedBuildingId =
      this.stateManagementService.getSharedData()?.selectedBuilding?.buildingId;
    this.selectedFloorId =
      this.stateManagementService.getSharedData()?.selectedFloor?.floorId;

    this.subscription = this.sharedDataService.currentData.subscribe(
      (sharedData) => {
        this.sharedData = sharedData;
        if (
          this.sharedData?.selectedUnit?.unitName &&
          this.selectedUnitName != sharedData?.selectedUnit?.unitName
        ) {
          this.selectedUnitName = sharedData?.selectedUnit?.unitName;
        }
      }
    );
    this.formGroup = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormGroup;
  }

  /**
   * @description close modal dialogue with help of material service
   * @returns void
   */
  closeDialog(): void {
    this.dialogRef?.close();
  }

  /**
   * @description validate form if form hold value into main form and redirect to navigateToDeviceInfo step
   * @returns void
   */
  navigateToDeviceInfo(): void {
    this.stepperChange.emit((this.stepper = 6));
  }

  /**
   * @description  #navigateToUpdateDeviceName function redirect to navigateToUpdateDeviceName step
   * @returns void
   */
  navigateToUpdateDeviceName(): void {
    this.stepperChange.emit((this.stepper = 2));
  }

  /**
   * @description #navigateToUsers functions redirects to navigateToUsers step
   * @returns void
   */
  navigateToUsers(): void {
    if (this.formInstance?.usersAccess?.value === '0') return;
    else this.stepperChange.emit((this.stepper = 5));
  }

  /**
   * @description #navigateToDoorMode functions redirects to navigateToDoorMode step
   * @returns void
   */
  navigateToDoorMode(): void {
    this.stepperChange.emit((this.stepper = 7));
  }

  /**
   * @description validate form if form hold valid value into main form and redirect to next step
   * @returns void
   */
  submit(): void {
    this.submited = true;
    if (this.formGroup?.invalid) return;
  }

  /**
   * @description #removeLock function will remove the lock o funit from the system
   * @returns void
   */
  removeLock(): void {
    const dialogInstance = this.helperService.openModalDialog(
      ConfirmRemoveDialogComponent,
      {
        title: this.translate.instant('REMOVE_LOCK'),
        bodyText: this.translate.instant(
          'ARE_YOU_SURE_YOU_WANT_TO_REMOVE_LOCK'
        ),
        footerText: this.translate.instant(
          'BY_MOVING_FORWARD_YOU_WILL_LOSE_INFORMATION_LOCK'
        ),
      },
      CONSTANTS.FIXED_SCREEN_MODAL
    );
    dialogInstance.afterClosed().subscribe((result: boolean) => {
      if (!result) return;
      this.deviceSettingservice
        .deleteLockDevice(this.formInstance.deviceId.value)
        .subscribe({
          next: (res: any) => {
            if (res && res?.deleteDevice?.deviceId) {
              this.closeDialog();
              this.notificationService.showSuccess(
                this.commonService.stringInterPolation(
                  this.translate.instant('SUCCESSFULLY_DELETED'),
                  this.translate.instant('LOCK')
                )
              );
              this.floorManagementService
                .getUnitsAndAccessPointsByFloor(
                  this.selectedSiteId,
                  this.selectedBuildingId,
                  this.selectedFloorId
                )
                .subscribe();
            }
          },
          error: (err: Error) => {
            if (window.__dev__) console.log('deleteDevice', err);
            this.notificationService.showError(err?.message);
          },
        });
    });
  }
  /**
   * @description #removeDevice function will remove the lock o funit from the system
   * @returns void
   */
  removeDevice(deviceType: string): void {
    if (deviceType === CONSTANTS.COMBO_READER || CONSTANTS.CONTROLLER) {
      const dialogInstance = this.helperService.openModalDialog(
        ConfirmRemoveDialogComponent,
        {
          title: this.translate.instant('REMOVE_DEVICE'),
          bodyText: this.translate.instant(
            'ARE_YOU_SURE_YOU_WANT_TO_REMOVE_DEVICE'
          ),
          footerText: this.translate.instant(
            'BY_MOVING_FORWARD_YOU_WILL_LOSE_INFORMATION_DEVICE'
          ),
        },
        CONSTANTS.FIXED_SCREEN_MODAL
      );
      dialogInstance.afterClosed().subscribe((result: boolean) => {
        if (!result) return;
        this.deviceSettingservice
          .deletPartnerDevice(this.formInstance.deviceId.value)
          .subscribe({
            next: (res: any) => {
              if (res && res?.deletePartnerDevice?.deviceId) {
                this.floorManagementService
                  .getPartnerDevicesByAccessPoint(
                    this.formInstance.accessPointId.value
                  )
                  .subscribe();
                //Test success message
                this.notificationService.showSuccess(
                  this.commonService.stringInterPolation(
                    this.translate.instant('SUCCESSFULLY_DELETED,'),
                    this.translate.instant('DEVICE')
                  )
                );
                this.closeDialog();
              }
            },
            error: (err: Error) => {
              if (window.__dev__) console.log('deleteDevice', err);
              this.notificationService.showError(err?.message);
            },
          });
      });
    } else {
      this.deviceSettingservice
        .deletPartnerDevice(this.formInstance.deviceId.value)
        .subscribe({
          next: (res: any) => {
            if (res && res?.deletePartnerDevice?.deviceId) {
              //Test success message
              this.notificationService.showSuccess(
                this.commonService.stringInterPolation(
                  this.translate.instant('SUCCESSFULLY_DELETED'),
                  this.translate.instant('DEVICE')
                )
              );
              this.closeDialog();
            }
          },
          error: (err: Error) => {
            if (window.__dev__) console.log('deleteDevice', err);
            this.notificationService.showError(err?.message);
          },
        });
    }
  }

  /**
   * @description #updateEnable function will update the device operation by calling
   *               updateDeviceEnablingState API.
   * @returns void
   */

  updateEnable(operation: boolean): void {
    this.deviceSettingservice
      .updateDeviceEnablingState(this.formInstance.deviceId.value, operation)
      .subscribe({
        next: (res: any) => {
          if (res && res?.updateEnablingState?.deviceId) {
            this.stepperChange.emit((this.stepper = 1));
            this.formInstance.enabled.setValue(operation);
            this.notificationService.showSuccess(
              this.commonService.stringInterPolation(
                this.translate.instant('UPDATED_SUCCESSFULLY'),
                this.translate.instant('DEVICE')
              )
            );
          }
        },
        error: (err: Error) => {
          if (window.__dev__) console.log('updateDevice', err);
          this.notificationService.showError(err?.message);
        },
      });
  }

  /**
   * @description: #getBatteryError function recieves battery percentage and activavtionstate and return the appropriate error message.
   * @param { string } batteryPercentage
   * @param { string } state
   * @returns { string } battery error
   */
  getBatteryError(activationState: string, batteryPercentage: string): string {
    let error: string = '';
    switch (true) {
      case activationState === CONSTANTS.PENDING_ACTIVATION:
        error = this.translate.instant('LOCK_INSTALLED_PROCESS');
        break;
      case this.getBatteryPercentage(batteryPercentage) >=
        Number(CONSTANTS.ELEVEN_PERCENT) &&
        this.getBatteryPercentage(batteryPercentage) <=
          Number(CONSTANTS.BATTERY_ALARAM_PERCENTAGE):
        error = this.commonService.stringInterPolation(
          this.translate.instant('BATTERY_IS_LOW'),
          `${batteryPercentage.toString()}%`
        );
        break;
      case this.getBatteryPercentage(batteryPercentage) >=
        Number(CONSTANTS.ONE_PERCENT) &&
        this.getBatteryPercentage(batteryPercentage) <=
          Number(CONSTANTS.TEN_PERCENT):
        error = this.commonService.stringInterPolation(
          this.translate.instant('BATTERY_IS_LOW'),
          `${batteryPercentage.toString()}%`
        );
        break;
      case this.getBatteryPercentage(batteryPercentage) ===
        Number(CONSTANTS.ZERO_PERCENT):
        error = this.commonService.stringInterPolation(
          this.translate.instant('BATTERY_IS_LOW'),
          `${batteryPercentage.toString()}%`
        );
        break;
      default:
        error = '';
        break;
    }
    return error;
  }

  /**
   * @description: #getBatteryPercentage function recieves battery percentage in string and converts it to number.
   * @param { string } batteryPercentage
   * @returns { number } battery
   */

  getBatteryPercentage(batteryPercentage: string): number {
    batteryPercentage = String(batteryPercentage)?.replace('%', '');
    return parseInt(batteryPercentage);
  }

  onSeeDetails(title: string) {
    this.helperService.openModalDialog(
      ViewAlertDetailsComponent,
      {
        title,
      },
      CONSTANTS.FIXED_SCREEN_MODAL
    );
  }
  helpFaqs(): void {
    const brand = this.stateManagementService?.getUserBrand();
    const Lang = this.stateManagementService?.getUserLanguage();
    if(brand === BRANDS.WEISER){
      if(Lang === LANG_CONST.FRENCH) {
        window.open(CONSTANTS.HELP_LINK_FRENCH_WEISER, '_blank');
      }
      else {
        window.open(CONSTANTS.HELP_LINK_WEISER, '_blank');
      }
    }
    else {
      window.open(CONSTANTS.HELP_AND_FAQ_LINK, '_blank');
    }
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
